import { render, staticRenderFns } from "./CardFrame.vue?vue&type=template&id=a63db6dc&scoped=true"
import script from "./CardFrame.vue?vue&type=script&lang=js"
export * from "./CardFrame.vue?vue&type=script&lang=js"
import style0 from "./CardFrame.vue?vue&type=style&index=0&id=a63db6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63db6dc",
  null
  
)

export default component.exports